import jsPDF from 'jspdf'
import 'jspdf-autotable'
export default {
  data() {
    return{
      tableTop: 60
    }
  },
  methods: {
    generatePdf(name, tableId) {
      const doc = new jsPDF("p", "pt");
      doc.autoTable({  
        html: `#${tableId}`,
        styles : { halign : 'start'},
        headStyles :{fillColor : [240, 240, 240], textColor: [0, 0, 0]},
        alternateRowStyles: {fillColor : [255, 252, 252]},
        theme: 'grid',
        columnStyles: tableId === 'booking-pdf-table' ? {
          0: {columnWidth: 25}, 
          1:{columnWidth: 40}, 
          2: {columnWidth: 60}, 
          3: {columnWidth: 50},
          4: {columnWidth: 40},
          5: {columnWidth: 60},
          6: {columnWidth: 50},
          7: {columnWidth: 60},
          8: {columnWidth: 30},
          9: {columnWidth: 50},
          10: {columnWidth: 50},
         } : {},
        // tableLineColor: [124, 95, 240],
        // tableLineWidth: 0.1,
        startY: this.tableTop,
      })
      doc.save(`${name}.pdf`);
    }
  }
}